import HeatmapClass, * as HeatmapModule from './../../node_modules/ol/layer/Heatmap.js';

// Create a wrapper class
class Heatmap extends HeatmapClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in HeatmapModule) {
    if (key !== "default") {
        Heatmap[key] = HeatmapModule[key];
    }
}

export default Heatmap;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/layer/Heatmap.js';